export default "__VITE_ASSET__Dz$1VzeJ__"